import React from "react";
import ReactDOM from 'react-dom';
import Countdown from 'react-countdown';
import { observer, inject } from "mobx-react";

@inject("store")
@observer
export default class DocTypeCountdown extends React.Component {

    constructor(props) {
        super(props);
        
        this.renderer = this.renderer.bind(this);
    }
    
    renderer({ days, hours, minutes, seconds, completed }) {
        let navigation = this.props.store.navigation;
        let divider = this.props.model.divider ? this.props.model.divider : " ";
        let titles = this.props.model.showTitles === "1";
        
        let itemMargin = (this.props.model.itemMargin || "7") + "px";
        let itemBackground = this.props.model.itemBackgroundColor || "unset";
        let itemBorderRadius = (this.props.model.itemBorderRadius || "0") + "px";
        
        
        if (completed) {
            // Render a completed state
            return <div className={"countdown-container"}>{navigation.dictionary.countdowncompleted || "Countdown completed"}</div>
        } else {
            // Render a countdown
            return <div className={"countdown-container"}>
                        <div className={"countdown-content countdown " + this.props.model.styleClass}>
                            <div className={"item"} style={{margin: itemMargin}}>
                                <div className={"days"} style={{backgroundColor: itemBackground, borderRadius: itemBorderRadius}}>{("0" + days).slice(-2)}</div>
                                {titles && <div className={"item-title"}>{navigation.dictionary.days || "days"}</div>}
                            </div>
                            <div className={"item"} style={{margin: itemMargin}}>
                                <div className={"hours"} style={{backgroundColor: itemBackground, borderRadius: itemBorderRadius}}>{("0" + hours).slice(-2)}</div>
                                {titles && <div className={"item-title"}>{navigation.dictionary.hours || "hours"}</div>}
                            </div>
                            <div className={"item"} style={{margin: itemMargin}}>
                                <div className={"minutes"} style={{backgroundColor: itemBackground, borderRadius: itemBorderRadius}}>{("0" + minutes).slice(-2)}</div>
                                {titles && <div className={"item-title"}>{navigation.dictionary.minutes || "minutes"}</div>}
                            </div>
                            <div className={"item"} style={{margin: itemMargin}}>
                                <div className={"seconds"} style={{backgroundColor: itemBackground, borderRadius: itemBorderRadius}}>{("0" + seconds).slice(-2)}</div>
                                {titles && <div className={"item-title"}>{navigation.dictionary.seconds || "seconds"}</div>}
                            </div>
                        </div>
                    </div>;
        }
    }
    
    render() {
        let datetime = this.props.model.deadline.replace(' ', 'T');
        return (<Countdown
            date={Date.parse(datetime)}
            renderer={this.renderer}
        />); 
    }
}